module.exports = __webpack_public_path__ + "static/scale-model-of-ward-meade-park-in-topeka-kansas-750f4e3707d3ab659ac38bfbf93e02ce.png";